import { render, staticRenderFns } from "./QuestionsDesktop.vue?vue&type=template&id=56aeff85&scoped=true&"
import script from "./QuestionsDesktop.vue?vue&type=script&lang=ts&"
export * from "./QuestionsDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsDesktop.vue?vue&type=style&index=0&id=56aeff85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aeff85",
  null
  
)

component.options.__file = "QuestionsDesktop.vue"
export default component.exports